import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import AddNewProperty from './AddNewProperty';
import PlayWithExisted from './PlayWithExisted';
import styles from './styles.module.scss';
import SearchProperty from './SearchProperty';
import ContextApp from './context';
import { bindChatFiles } from './utils';

const RentGptRoot = ({ formId = undefined, searchBarId = undefined }) => {
  useEffect(() => {
    bindChatFiles();
  }, []);
  return (
    <ContextApp>
      <div className="container">
        <SearchProperty boxId={searchBarId} formId={formId} />
        <div className={styles.orSep}>or</div>
        <PlayWithExisted boxId={searchBarId} />
        <AddNewProperty boxId={formId} />
      </div>
      <div id="rg-recaptcha-demo" style={{ display: 'none' }} />
    </ContextApp>
  );
};


RentGptRoot.propTypes = {
  searchBarId: PropTypes.string,
  formId: PropTypes.string,
};

export default RentGptRoot;
